import React, { useEffect, useState } from "react";
import * as url from "../../../../helpers/url_helper";
import { useSelector } from "react-redux";
import ChipsDataTable from "./ChipsDetail/ChipsDataTable";
import DataTable from "react-data-table-component";
import { convertProfileLocalDate } from "../../../../Utils/configController";
import { toast } from "react-toastify";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { ActionButton } from "../../../../components/Common/button";
import { MqttIcon, OtaIcon, PingIcon } from "../../../../assets/svg";
import { OPERATE_MQTT } from "../../../../helpers/socketEvent";
import { useSocket } from "../../../../Utils/socket";
import OtaModel from "./OtaModal";

export interface ChipsControlProps {
  userId: any;
  selectedPremise?: any;
}
const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");

const GatewayList = ({ userId, selectedPremise }: ChipsControlProps) => {
  const selectedRooms = useSelector(
    (state: any) => state.APIResponse.selectedRooms,
  );
  const socket: any = useSocket();
  const [loading, setLoading] = useState<boolean>(false);
  const [isReload, setReload] = useState<boolean>(false);

  const [selectedRows, setSelectedRows] = useState<any[]>([]);

  const [isOpneRequestModel, setOpenRequestModel] = useState<boolean>(false);
  const [requestData, setRequestData] = useState<any>({});
  const [otaSlave, setOtaSlave] = useState<any>({});
  const [isOtaModalOpen, setIsOtaModalOpen] = useState(false);

  const handleViewRequest = (rowData: any) => {
    console.log("rowData.redisInfo: ", rowData);

    setOpenRequestModel(true);
    setRequestData(rowData.redisInfo);
  };
  const toggleRequestModel = () => {
    setOpenRequestModel(!isOpneRequestModel);
  };

  const handlePingClick = (row: any) => {
    if (row !== undefined) {
      const reqObj = {
        slave: row?.slave,
        tag: `airpanel-${userInfo?.id}`,
        cmd: "PG",
      };
      socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      handleRefresh();
      toast.success(`Ping sent to slave ${row?.slave}`);
    }
  };
  const handleMQTTData = (row: any) => {
    row?.slave
      ? window.open(`/debug-device-details/${row?.slave}`, "_blank")
      : "";
  };
  const handleOtaClick = (row: any) => {
    if (row !== undefined) {
      setIsOtaModalOpen(!isOtaModalOpen);
      setOtaSlave(row);
    }
  };
  const columns = [
    {
      name: "Slave",
      selector: (row: any) => row.slave || "-",
      sortable: true,
      wrap: true,
    },

    {
      name: "Name",
      selector: (row: any) => (row?.name ? row.name : "-"),
      sortable: true,
    },
    // {
    //   name: "Room",
    //   selector: (row: any) => row.roomName || "-",
    //   sortable: true,
    //   wrap: true,
    // },
    // {
    //   name: "HW-V",
    //   selector: (row: any) => row.hwVersion || "-",
    //   sortable: true,
    //   grow: 0.5,

    //   wrap: true,
    // },
    // {
    //   name: "WI-V",
    //   selector: (row: any) => row.wifiVersion || "-",
    //   sortable: true,
    //   wrap: true,
    //   grow: 0.5,
    // },

    {
      name: "WI-V(HW-V)",
      selector: (row: any) =>
        `${row.wifiVersion || "-"} (${row.hwVersion || "-"})`,
      sortable: true,
      grow: 0.5,
      wrap: true,
    },
    {
      name: "Net Key",
      selector: (row: any) => row?.netKey || "-",
      cell: (row: any) =>
        row?.netKey ? (
          <span
            style={{
              fontSize: "8px",
              cursor: "pointer",
              color: "#0d6efd",
            }}
            title="Click to copy"
            onClick={() => {
              navigator.clipboard.writeText(row?.netKey);
              toast.success("netKey copied");
            }}
          >
            {row?.netKey}
          </span>
        ) : (
          <span>-</span>
        ),
      sortable: true,
      grow: 1,
      wrap: true,
    },
    {
      name: "App Key",
      selector: (row: any) => row?.appKey || "-",
      cell: (row: any) =>
        row?.appKey ? (
          <span
            style={{
              fontSize: "8px",
              cursor: "pointer",
              color: "#0d6efd",
            }}
            title="Click to copy"
            onClick={() => {
              navigator.clipboard.writeText(row?.appKey);
              toast.success("Device Key copied");
            }}
          >
            {row?.appKey}
          </span>
        ) : (
          <span>-</span>
        ),
      sortable: true,
      grow: 1,
      wrap: true,
    },
    {
      name: "Status",
      selector: (row: any) => (row.isOnline ? "Online" : "Offline"),
      cell: (row: any) =>
        row.isOnline === true ? (
          <span className="font-size-11 badge-soft-success badge bg-secondary">
            online
          </span>
        ) : (
          <span className="font-size-11 badge-soft-danger badge bg-secondary">
            Offline
          </span>
        ),
      sortable: true,
      grow: 0.5,
      wrap: true,
    },
    {
      name: "Drivers No",
      selector: (row: any) => row.noOfAirDriver || "-",
      sortable: true,
      wrap: true,
    },
    {
      name: "Online Drivers",
      selector: (row: any) => row.onlineDrivers || "-",
      sortable: true,
      wrap: true,
    },
    {
      name: "Offline Drivers",
      selector: (row: any) => row.offlineDrivers || "-",
      sortable: true,
      wrap: true,
    },

    {
      name: "Signal",
      selector: (row: any) => (row.signalStrength ? row.signalStrength : 0),
      cell: (row: any) => (
        <div>
          <span style={{ fontWeight: "bold", color: "black" }}>
            {row.signalStrength || "-"}
          </span>{" "}
          ({row.ssid || "-"})
        </div>
      ),
      sortable: true,
      wrap: true,
    },

    {
      name: "Actions",
      grow: 2,
      cell: (row: any) => (
        <div className="d-flex align-items-center gap-2">
          <ActionButton
            id="PingIconButton"
            title="Ping"
            icon={<PingIcon />}
            onClick={() => handlePingClick(row)}
          />
          <ActionButton
            id="MQTTLogsIconButton"
            title="MQTT Logs"
            icon={<MqttIcon />}
            onClick={() => handleMQTTData(row)}
          />
          <ActionButton
            id="OTAIconButton"
            title="OTA"
            icon={<OtaIcon />}
            onClick={() => handleOtaClick(row)}
          />
          <button
            className="btn btn-sm btn-primary"
            style={{
              // minWidth: "40px",
              padding: "10 6px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              whiteSpace: "nowrap",
            }}
            onClick={() => handleViewRequest(row)}
          >
            More
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const handleRefresh = () => {
    setReload((prev) => !prev);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      handleRefresh();
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      {/* VIEW REQUEST MODEL */}
      <Modal
        isOpen={isOpneRequestModel}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        // tabIndex="-1"
        toggle={toggleRequestModel}
      >
        <div className="modal-content">
          <ModalHeader style={{ justifyContent: "center" }}>
            {"Request"}
          </ModalHeader>
          <ModalBody>
            {/* {requestData} */}
            <pre style={{ whiteSpace: "pre-wrap" }}>
              {JSON.stringify(requestData, null, 2)}
            </pre>
          </ModalBody>
          <ModalFooter style={{ justifyContent: "center" }}>
            <button
              className="btn btn-dark"
              type="submit"
              onClick={() => setOpenRequestModel(false)}
            >
              Ok
            </button>
          </ModalFooter>
        </div>
      </Modal>
      {isOtaModalOpen && (
        <OtaModel
          headerTitle="OTA"
          otaSlave={otaSlave}
          cancleBtnClick={() => setIsOtaModalOpen(false)}
        />
      )}
      <ChipsDataTable
        apiURL={`${url.BASE_URL}${url.GET_GATEWAY_LIST}`}
        title="Gateway List"
        customStyles={customStyles}
        selectedRoomID={selectedRooms}
        columns={columns}
        isReload={isReload}
        expandableRows={true}
        ExpandedComponent={ExpandedComponent}
        ExpandCollapseIcon={ExpandCollapseIcon}
        idName={"Gatewaylist"}
        loading={loading}
        setLoading={setLoading}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        userId={userId}
        selectedPremise={selectedPremise}
      />
    </div>
  );
};

export default GatewayList;

export const ExpandedComponent = ({ data }: { data: any }) => {
  const driversColumns: any[] = [
    {
      name: "Name",
      selector: (row: any) => row?.name || "-",
      sortable: true,
      grow: 1.5,
      wrap: true,
    },
    {
      name: "Slave",
      selector: (row: any) => row?.slave || "-",
      sortable: true,
      grow: 1.5,
      wrap: true,
    },
    {
      name: "Room",
      selector: (row: any) => row.roomName || "-",
      sortable: true,
      wrap: true,
    },
    {
      name: "Node ID",
      selector: (row: any) => row?.nodeId || "-",
      sortable: true,
      grow: 0.8,
      wrap: true,
    },
    {
      name: "UUID",
      selector: (row: any) => row?.uuid || "-",
      cell: (row: any) =>
        row?.uuid ? (
          <span
            style={{
              fontSize: "8px",
              cursor: "pointer",
              color: "#0d6efd",
            }}
            title="Click to copy"
            onClick={() => {
              navigator.clipboard.writeText(row?.uuid);
              toast.success("UUID copied");
            }}
          >
            {row?.uuid}
          </span>
        ) : (
          <span>-</span>
        ),
      sortable: true,
      grow: 1,
      wrap: true,
    },
    {
      name: "Device Key",
      selector: (row: any) => row?.devKey || "-",
      cell: (row: any) =>
        row?.devKey ? (
          <span
            style={{
              fontSize: "8px",
              cursor: "pointer",
              color: "#0d6efd",
            }}
            title="Click to copy"
            onClick={() => {
              navigator.clipboard.writeText(row?.devKey);
              toast.success("Device Key copied");
            }}
          >
            {row?.devKey}
          </span>
        ) : (
          <span>-</span>
        ),
      sortable: true,
      grow: 1,
      wrap: true,
    },
    {
      name: "Type",
      selector: (row: any) => row?.deviceTypeTag || "-",
      sortable: true,
      grow: 0.5,
      wrap: true,
    },
    {
      name: "Configured",
      selector: (row: any) => (row?.isConfigured ? "Yes" : "No"),
      cell: (row: any) =>
        row?.isConfigured ? (
          <span className="font-size-11 badge-soft-success badge bg-success">
            Yes
          </span>
        ) : (
          <span className="font-size-11 badge-soft-danger badge bg-danger">
            No
          </span>
        ),
      sortable: true,
      grow: 0.8,
      wrap: true,
    },
    {
      name: "Status",
      selector: (row: any) => (row?.isOnline ? "Online" : "Offline"),
      cell: (row: any) =>
        row?.isOnline ? (
          <span className="font-size-11 badge-soft-success badge bg-success">
            Online
          </span>
        ) : (
          <span className="font-size-11 badge-soft-danger badge bg-danger">
            Offline
          </span>
        ),
      sortable: true,
      grow: 0.5,
      wrap: true,
    },
    {
      name: "Power",
      selector: (row: any) => (row?.isOn ? "ON" : "OFF"),
      cell: (row: any) =>
        row?.isOn ? (
          <span className="font-size-11 badge-soft-success badge bg-success">
            ON
          </span>
        ) : (
          <span className="font-size-11 badge-soft-danger badge bg-danger">
            OFF
          </span>
        ),
      sortable: true,
      grow: 0.5,
      wrap: true,
    },
    {
      name: "Brightness",
      selector: (row: any) => row?.brightness ?? "-",
      sortable: true,
      grow: 0.5,
      wrap: true,
    },
    {
      name: "Temperature",
      selector: (row: any) => row?.temp ?? "-",
      sortable: true,
      grow: 0.5,
      wrap: true,
    },
  ];

  // Create table rows including static counts
  const driversData = data?.drivers || [];

  return (
    <div className="p-2">
      <DataTable
        columns={driversColumns}
        data={driversData}
        dense
        highlightOnHover
        noDataComponent="No drivers available"
        customStyles={customStyles}
        expandableRows={false}
        expandableIcon={{
          collapsed: <ExpandCollapseIcon expanded={false} />,
          expanded: <ExpandCollapseIcon expanded={true} />,
        }}
      />
    </div>
  );
};
export const customStyles: any = {
  tableWrapper: {
    style: {
      minWidth: "1100px",
    },
  },
  subHeader: {
    style: {
      padding: "0px",
      margin: "0px",
    },
  },
  headRow: {
    style: {
      backgroundColor: "#EFF2F7",
      fontWeight: "bold",
      fontSize: "14px",
      borderBottom: "none",
    },
  },
  rows: {
    style: {
      fontSize: "14px",
      color: "#343a40",
      borderBottom: "none",
    },
  },
  cells: {
    style: {
      fontSize: "14px",
      color: "#343a40",
      borderBottom: "none",
    },
  },
};

export const ExpandCollapseIcon = ({ expanded }: { expanded: boolean }) => {
  return (
    <div
      className="d-flex justify-content-center align-items-center  "
      style={{ cursor: "pointer", width: "32px", height: "32px" }}
    >
      <i
        className={`bx ${
          expanded ? "bx-caret-down" : "bx-caret-right"
        } text-dark fs-5`}
      ></i>
    </div>
  );
};
